/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      ol: "ol",
      li: "li",
      pre: "pre",
      code: "code"
    }, _provideComponents(), props.components);
    return _jsxs(_Fragment, {
      children: [_jsxs(_components.ol, {
        children: ["\n", _jsx(_components.li, {}), "\n"]
      }), "\n", _jsx(_components.pre, {
        children: _jsx(_components.code, {
          className: "language-ts",
          children: "interface Observable {\n  listeners: Observer[]\n  subscribe(observer: Observer): void\n  unsubscribe(observer: Observer): void\n  notify(data: any): void\n}\n"
        })
      })]
    });
  }
}
export default MDXContent;
